import store from '../../store';

export default async (to, from, next) => {
    let userRoles = store.state?.auth?.user ? store.state?.auth?.user.data.role : undefined;
    let url = '';

    if(userRoles?.includes('super_admin')){
        url = '/organizations';
    }else if(userRoles?.includes('admin')){
        url = '/settings/user';
    }else{
        url = '/';
    }

    if (store.getters['authenticated']){
        next({path: url});
    } else {
        next({name: 'login-page'});
    }
}